import { Button, Grid, Typography } from "@mui/material";
import Input from "./Input";
import { Controller, FieldValues, useForm } from "react-hook-form";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import PasswordIcon from "@mui/icons-material/Password";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import { useSnackbar } from "../context/SnackbarContext";
export interface RecoverPasswordData {
  email: string;
  resetCode: string;
  newPassword: string;
  confirmNewPassword: string;
}

interface RecoverPasswordFormProps {
  onSubmit: (data: RecoverPasswordData) => void;
  isLoading: boolean;
  defaultEmail: string;
}

const RecoverPasswordForm = ({
  onSubmit,
  isLoading,
  defaultEmail,
}: RecoverPasswordFormProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { showSnackbar } = useSnackbar();

  const { handleSubmit, control } = useForm<RecoverPasswordData>({
    defaultValues: {
      email: defaultEmail,
    },
  });
  const onSubmitHandler = (data: RecoverPasswordData) => {
    if (data.newPassword !== data.confirmNewPassword) {
      showSnackbar("Las contraseñas no coinciden", "error", 5000);
      return;
    }
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmitHandler)}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "El correo electrónico es requerido",
            }}
            name="email"
            render={({ field, fieldState }) => (
              <Input
                label="Usuario"
                name="username"
                required
                field={field}
                error={fieldState.error?.message}
                icon={<AlternateEmailIcon />}
                disabled={true}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "El código de confirmación es requerido",
            }}
            name="resetCode"
            render={({ field, fieldState }) => (
              <Input
                label="Código de confirmación"
                name="resetCode"
                required
                field={field}
                error={fieldState.error?.message}
                icon={<PasswordIcon />}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "La nueva contraseña es requerida",
            }}
            name="newPassword"
            render={({ field, fieldState }) => (
              <Input
                label="Nueva contraseña"
                name="newPassword"
                required
                field={field}
                error={fieldState.error?.message}
                icon={showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                type={showPassword ? "text" : "password"}
                onClickIcon={() => setShowPassword(!showPassword)}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <Controller
            control={control}
            rules={{
              required: "La confirmación de la nueva contraseña es requerida",
            }}
            name="confirmNewPassword"
            render={({ field, fieldState }) => (
              <Input
                label="Confirmar nueva contraseña"
                name="confirmNewPassword"
                required
                field={field}
                error={fieldState.error?.message}
                icon={
                  showConfirmPassword ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )
                }
                type={showConfirmPassword ? "text" : "password"}
                onClickIcon={() => setShowConfirmPassword(!showConfirmPassword)}
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          disabled={isLoading}
          loading={isLoading}
        >
          Ingresar
        </Button>
      </Grid>
    </form>
  );
};

export default RecoverPasswordForm;
